module.exports = __webpack_public_path__ + "img/welcome.db904c2a.png";